import React, { useRef, useEffect } from 'react'
import lottie from 'lottie-web'
import getStaticPath from 'functions/getStaticPath'
import gsap from 'gsap'
import styles from './global.module.scss'

const Loading = () => {
  const ContainerLottieRef = useRef(null)

  useEffect(() => {
    const logoAnimation = lottie.loadAnimation({
      container: ContainerLottieRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: getStaticPath('/loading/SaddlesLoadingAnimation.json'),
    })
    logoAnimation.play()
    gsap.to(ContainerLottieRef.current, { opacity: 1, duration: 0.4 })
  }, [])

  return (
    <div className={styles.loadingWrapper}>
      <div ref={ContainerLottieRef} className={styles.loading} />
    </div>
  )
}

export default Loading
